import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMarkaSecSatinAlma_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMarkaSecSatinAlma_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetInvoicePurchaseBrandCharSelect: any[];
  GetInvoicePurchaseBrandCharSelect_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp566618Visible: "visible" | "hidden";
  isComp285120Visible: "visible" | "hidden";
}

export class MarkaSecSatinAlma_ScreenBase extends React.PureComponent<
  IMarkaSecSatinAlma_ScreenProps,
  any
> {
  markasecsatinalma_534476_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "0ee34b49-763f-4958-a0ca-678ee7588bed",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 213326, PropertyName: "value", Value: "Marka Seç" },
        { Id: 994363, PropertyName: "value", Value: "Tedarikçi Adı" },
        { Id: 271708, PropertyName: "value", Value: "21.02.2025" },
        { Id: 637643, PropertyName: "value", Value: "-" },
        { Id: 771594, PropertyName: "value", Value: "21.02.2025" },
        { Id: 878040, PropertyName: "placeholder", Value: "Marka Adı..." },
        { Id: 824856, PropertyName: "label", Value: "Ara" },
        { Id: 119978, PropertyName: "label", Value: "Temizle" },
        { Id: 730031, PropertyName: "title", Value: "Title" },
        {
          Id: 522196,
          PropertyName: "value",
          Value: "[datafield:productatt02desc]",
        },
        { Id: 428585, PropertyName: "value", Value: "Miktar" },
        { Id: 947390, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 215096, PropertyName: "value", Value: "Tutar" },
        { Id: 496763, PropertyName: "value", Value: "[datafield:tutar]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.markasecsatinalma_878040_value_kuikaTextInputRef = React.createRef();
    this.markasecsatinalma_534476_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetInvoicePurchaseBrandCharSelect: [],
      SetValueOf: "",
      NAVIGATE: "",
      isComp566618Visible: "hidden",
      isComp285120Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("markasecsatinalma", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MarkaSecSatinAlmaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("markasecsatinalma", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("markasecsatinalma", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MarkaSecSatinAlmaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MarkaSecSatinAlmaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      ),
      collectionName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MarkaSecSatinAlma/MarkaSecSatinAlmaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseBrandCharSelect =
      result?.data.getInvoicePurchaseBrandCharSelect;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MarkaSecSatinAlmaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MarkaSecSatinAlmaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_534476 =
      stateVars.GetInvoicePurchaseBrandCharSelect ??
      this.state.GetInvoicePurchaseBrandCharSelect;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MarkaSecSatinAlmaComponent_935703_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MarkaSecSatinAlmaComponent_824856_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      ),
      collectionName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "markasecsatinalma_878040_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MarkaSecSatinAlma/MarkaSecSatinAlmaComponent_824856_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseBrandCharSelect =
      result?.data.getInvoicePurchaseBrandCharSelect;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MarkaSecSatinAlmaComponent_824856_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MarkaSecSatinAlmaComponent_824856_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_534476 =
      stateVars.GetInvoicePurchaseBrandCharSelect ??
      this.state.GetInvoicePurchaseBrandCharSelect;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MarkaSecSatinAlmaComponent_119978_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "markasecsatinalma_878040_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MarkaSecSatinAlmaComponent_119978_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MarkaSecSatinAlmaComponent_119978_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      ),
      collectionName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MarkaSecSatinAlma/MarkaSecSatinAlmaComponent_119978_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseBrandCharSelect =
      result?.data.getInvoicePurchaseBrandCharSelect;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MarkaSecSatinAlmaComponent_119978_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MarkaSecSatinAlmaComponent_119978_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_534476 =
      stateVars.GetInvoicePurchaseBrandCharSelect ??
      this.state.GetInvoicePurchaseBrandCharSelect;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MarkaSecSatinAlmaComponent_26565_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "KategorSeciDetaySatinAlma",
      "VendorName",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorName ??
          this.props.screenInputs.vendorname,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KategorSeciDetaySatinAlma",
      "BrandName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "markasecsatinalma_534476_value",
          "productAtt02Desc"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KategorSeciDetaySatinAlma",
      "TotalQty1",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "markasecsatinalma_534476_value",
          "miktar"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KategorSeciDetaySatinAlma",
      "TotalAmount",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "markasecsatinalma_534476_value",
          "tutar"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KategorSeciDetaySatinAlma",
      "VendorCode",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VendorCode ??
          this.props.screenInputs.vendorcode,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KategorSeciDetaySatinAlma",
      "dateFilter",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.dateFilter ??
          this.props.screenInputs.datefilter,
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MarkaSecSatinAlma",
      "KategorSeciDetaySatinAlma",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MarkaSecSatinAlmaPageInit();
    }
  }
}
